import { render, staticRenderFns } from "./DiseasesPieChart.vue?vue&type=template&id=4b643419"
import script from "./DiseasesPieChart.vue?vue&type=script&lang=js"
export * from "./DiseasesPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports